import { StoreConfig } from "src/utils/storeConfig";
import {
  ShippingMethod,
  ShippingRate,
  Cart,
  Money,
} from "src/types/ctgraphql.d";
import { lineItemsWithDiscountCodesTotalPrice } from "src/utils/ct/totalPrice";

export const isShippingPriceFree = (cart: Cart): boolean => {
  return (
    Number(
      cart.shippingInfo?.discountedPrice
        ? cart.shippingInfo.discountedPrice.value.centAmount
        : cart.shippingInfo?.price.centAmount
    ) === 0
  );
};

export const getShippingRate = (
  shippingMethod: ShippingMethod | undefined,
  storeConfig: StoreConfig,
  cart: Cart
): ShippingRate | undefined => {
  return shippingMethod?.zoneRates
    .find(({ zone }) => zone?.name === cart.shippingAddress?.country)
    ?.shippingRates.find(
      ({ price }) => price.currencyCode === storeConfig.currencyCode
    );
};

export const getShippingMethodPrice = (
  cart: Cart,
  shippingMethod: ShippingMethod,
  storeConfig: StoreConfig
): Money | undefined => {
  if (isShippingPriceFree(cart)) {
    return undefined;
  } else {
    const shippingRate = getShippingRate(shippingMethod, storeConfig, cart);
    return lineItemsWithDiscountCodesTotalPrice(
      cart.lineItems,
      cart.discountCodes
    ).centAmount >= shippingRate?.freeAbove?.centAmount
      ? undefined
      : shippingRate?.price;
  }
};
